import _ from "lodash";
import { IEntrySelection } from "./fileModel";

export function formatFileCount(files: number) {
    return `${files} dokument`;
}

export function formatFolderCount(folders: number) {
    return folders === 1 ? '1 mapp' : `${folders} mappar`;
}

export function formatStatsMessage(stats: ISelectionStatPart) {
    if (stats.fileCount > 0 && stats.folderCount > 0) {
        return `${formatFolderCount(stats.folderCount)} och ${formatFileCount(stats.fileCount)}`;
    } else if (stats.folderCount > 0) {
        return formatFolderCount(stats.folderCount);
    } else {
        return formatFileCount(stats.fileCount);
    }
}

export function formatStatsSelection(stats: ISelectionStatPart) {
    if (stats.fileCount > 0 && stats.folderCount > 0) {
        return `${formatFolderCount(stats.folderCount)} och ${formatFileCount(stats.fileCount)} är markerade`;
    } else if (stats.folderCount === 1) {
        return '1 mapp är markerad';
    } else if (stats.folderCount > 1) {
        return `${stats.folderCount} mappar är markerade`;
    } else if (stats.fileCount === 1) {
        return '1 dokument är markerat';
    } else {
        return `${stats.fileCount} dokument är markerade`;
    }
}

export interface ISelectionStatPart {
    entries: number;
    folderCount: number;
    fileCount: number;
}

export interface ISelectionStats {
    immediate: ISelectionStatPart;
    total: ISelectionStatPart;
}

function getPart(files: number, folders: number): ISelectionStatPart {
    return {
        entries: files + folders,
        fileCount: files,
        folderCount: folders,
    }
}

export function getSelectionStats(selection: IEntrySelection): ISelectionStats {
    const subFileCount = _.sumBy(selection.folders, x => x.totalFileCount);
    const subFolderCount = _.sumBy(selection.folders, x => x.totalFolderCount);
    return {
        immediate: getPart(selection.files.length, selection.folders.length),
        total: getPart(selection.files.length + subFileCount, selection.folders.length + subFolderCount),
    };
}
